/**
 * A helper function to prevent duplicate function calls for a given period.
 * Each time the function is triggered, it will not fire if there are any subsequent calls within the specified delay,
 * i.e. only the last call is executed.
 * @example
 * for (const i = 0; i < 10; i++)
 *  debouncedFn(i);
 * // only '9' will be logged, since each call from 0-8 will occur within 500ms of the last call
 *
 * @param fn The function to be executed
 * @param delay The amount of time (in ms) to wait for a duplicate function call
 * @returns A function wrapping the received function in a timeout
 */
export const debounce = (fn: (...args: any) => void, delay: number) => {
  let timeoutId: NodeJS.Timeout | undefined

  return (...args: any) => {
    if (timeoutId) clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      fn(...args)
    }, delay)
  }
}
